import { JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const putCustomerLink = async ({ taskId, customerId }: JsonDataItem) => {
  const data = await baseQuery('task/link-customer', {
    type: 'PUT',
    body: {
      task_ID: taskId,
      customer_ID: customerId,
    },
  });

  return data;
};
